import Dataset from './model/dataset'
const { isTotal } = Dataset
import _ from 'lodash'
import isDateTimeDataType from 'scoreboard/components/is-date-time-data-type'
import isGeographicOrRollup from './is-geographic-or-rollup'
import DataType from 'scoreboard/datasets/model/data-type'
import { LIST_UNIQUE_VALUES } from './model/aggregation-type'
const { TEXT, YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD } = DataType

const sum = { id: 'sum', label: 'scorecards.node.metric.aggregationType.sum', icon: 'sum' }
const average = { id: 'average', label: 'scorecards.node.metric.aggregationType.average', icon: 'average' }
const percentage = { id: 'percentage', label: 'scorecards.node.metric.dataType.percentage', icon: 'percent' }
const minimum = {id: 'minimum', label: 'datasets.minimum', icon: 'minimum'}
const maximum = { id: 'maximum', label: 'datasets.maximum', icon: 'maximum' }
const minimumDateForDate = { id: 'minimum', label: 'datasets.minimum.date', icon: 'minimum' }
const maximumDateForDate = { id: 'maximum', label: 'datasets.maximum.date', icon: 'maximum' }
const minimumTimeForTime = { id: 'minimum', label: 'datasets.minimum.time', icon: 'minimum' }
const maximumTimeForTime = { id: 'maximum', label: 'datasets.maximum.time', icon: 'maximum' }
const minimumDateForDateTime = { id: 'min-date', label: 'datasets.minimum.date', icon: 'minimum' }
const maximumDateForDateTime = { id: 'max-date', label: 'datasets.maximum.date', icon: 'maximum' }
const minimumTimeForDateTime = { id: 'min-time', label: 'datasets.minimum.time', icon: 'minimum' }
const maximumTimeForDateTime = { id: 'max-time', label: 'datasets.maximum.time', icon: 'maximum' }
const minimumDateTime = { id: 'minimum', label: 'datasets.minimum.dateTime', icon: 'minimum' }
const maximumDateTime = { id: 'maximum', label: 'datasets.maximum.dateTime', icon: 'maximum' }
const none = { id: 'none', label: 'datasets.none', icon: 'not-allowed' }
const unique = { id: 'unique', label: 'datasets.unique', icon: 'tally' }
const useEquation = { id: 'use-equation', label: 'scorecards.node.metric.aggregationType.useEquation', icon: 'calculated' }
const listUniqueValues = {
	id: LIST_UNIQUE_VALUES,
	label: 'common.listUniqueValues',
	icon: 'text'
}

/**
 * Returns the  aggregation types appropriate for the total display on the
 * datasets explore tab and for dataset value widgets
 * @param {Dataset} dataset
 * @param {Number} fieldIdentifier A field identifier is used to allow
 * us to mix field IDs and visibleLinkedFieldIds in a single select. We mix
 * them by multiplying the visibleLinkedFieldId by -1.
 * @returns {{icon: string, id: string, label: string}[]}*}
 */
function totalDisplay(dataset, fieldIdentifier) {
	let field = dataset.getFieldByFieldIdentifier(fieldIdentifier)
	if (isTotal(field.id)) {
		return [ sum ]
	}

	let options = forField(dataset, fieldIdentifier)

	// percentage doesn't make sense for the total display
	_.remove(options, option => option.id === 'percentage')

	return options
}

// aggregation types appropriate for creating/editing a dataset field
function forFieldEdit() {
	return [ sum, average, minimum, maximum, none ]
}

/**
 * Keep everything below in sync with {@link AggregationTypeOptions.kt}
 */

// aggregation types for display on the datasets overview
function nonTotalColumn(dataType) {
	if (dataType === YES_NO || isGeographicOrRollup(dataType) || dataType === TEXT
		|| dataType == CALENDAR_PERIOD) {
		return [ unique, listUniqueValues ]
	}
	if (dataType === DATE) {
		return date()
	}
	if (dataType === TIME) {
		return [ minimumTimeForTime, maximumTimeForTime, unique, listUniqueValues ]
	}
	if (dataType === DATE_TIME) {
		return [
			minimumDateForDateTime, minimumTimeForDateTime, minimumDateTime,
			maximumDateForDateTime, maximumTimeForDateTime, maximumDateTime,
			unique, listUniqueValues
		]
	}

	// #21748 #21749 none aggregation type shouldn't be allowed except when
	// editing fields, or else it should be the ONLY option and we don't need
	// to specify it here
	return [ sum, average, percentage, minimum, maximum, unique, listUniqueValues ]
}

// aggregation types allowed for "total <<tracked>>" e.g. Total Sexual Assaults
// used in the Choose Columns dialog, aka choose-columns.js
function totalColumn() {
	return [ sum, percentage ]
}

function date() {
	return [ minimumDateForDate, maximumDateForDate, unique, listUniqueValues ]
}

/**
 * Returns appropriate aggregation type options for the given field
 * @param {Dataset} dataset
 * @param {Number} fieldIdentifier A field identifier is used to allow
 * us to mix field IDs and visibleLinkedFieldIds in a single select. We mix
 * them by multiplying the visibleLinkedFieldId by -1.
 */
function forField (dataset, fieldIdentifier) {
	if (isTotal(fieldIdentifier)) {
		return totalColumn()
	} else {
		let field = dataset.getFieldByFieldIdentifier(fieldIdentifier)
		let underlyingField = dataset.getUnderlyingField(field)
		let dataType = underlyingField.dataType
		if (dataType == CALENDAR_PERIOD) {
			return [ unique, listUniqueValues ]
		} else if (dataType === DATE) {
			return date()
		} else {
			if (underlyingField.aggregationType === 'none') {
				return [ none ]
			} else {
				return nonTotalColumn(dataType)
			}
		}
	}
}

function breakdownSortAggregation(dataType) {
	if (isDateTimeDataType(dataType)) {
		return [minimum, maximum]
	}
	if (dataType == TEXT) {
		return []
	}
	return [ sum, average, minimum, maximum ]
}

export { totalDisplay, forFieldEdit, totalColumn, nonTotalColumn,
	date, forField, sum, average, percentage, minimum, maximum, none, unique,
	useEquation, breakdownSortAggregation, listUniqueValues, minimumDateForDate,
	maximumDateForDate }

